export default "__VITE_ASSET__wel9x4v6__"